import React, { useState } from "react";

import MaterialUI from "../../../../material-UI";
import * as Styles from "../../styles";

interface Props {
  onClose: Function;
  open: boolean;
  idLead?: string;
}

const RedirectModal: React.FC<Props> = ({ idLead }) => {
  const [loading] = useState<boolean>(false);
  return (
    <>
      <Styles.TransferComponent>
        <Styles.Subtitle>
          Lead existente no bolsão, iremos direcioná-lo para a sua carteira.
        </Styles.Subtitle>
      </Styles.TransferComponent>
      <Styles.Footer>
        <Styles.FooterDialog>
          <Styles.LinkButton href={`/lead-detail/${idLead}`}>
            {loading ? <MaterialUI.CircularProgress /> : "Visualizar lead"}
          </Styles.LinkButton>
        </Styles.FooterDialog>
      </Styles.Footer>
    </>
  );
};

export default RedirectModal;
